// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"084d3445","545":"52668487","828":"5b7d5e7b","985":"96447b85"}[chunkId] + ".chunk.js";
};